import { Option, none, isNone, some, isSome } from 'fp-ts/lib/Option';

export type WidgetDataProxyContext = {
    language: string | null;
    location: string | null;
    period: string | null;
    dashboardId: string | null;
    locationTags: string[] | null;
};
export default interface ReadWidgetDataCriteria {
    widgetId: string;
    destination: string;
    proxyContext: WidgetDataProxyContext;
    reportInstanceId: string | null;
}

class ReadWidgetDataCriteriaImpl implements ReadWidgetDataCriteria {
    constructor(
        readonly widgetId: string,
        readonly destination: string,
        readonly proxyContext: WidgetDataProxyContext,
        readonly reportInstanceId: string | null
    ) {}
}

export class ReadWidgetDataCriteriaBuilder {
    private widgetId: Option<string> = none;

    private destination: Option<string> = none;

    private proxyContext: Option<WidgetDataProxyContext> = none;

    private reportInstanceId: Option<string> = none;

    static create = (): ReadWidgetDataCriteriaBuilder => new ReadWidgetDataCriteriaBuilder();

    withWidgetId = (widgetId: string): ReadWidgetDataCriteriaBuilder => {
        this.widgetId = some(widgetId);

        return this;
    };

    withDestination = (destination: string): ReadWidgetDataCriteriaBuilder => {
        this.destination = some(destination);

        return this;
    };

    withReportTemplateProxyContext = (context: WidgetDataProxyContext): ReadWidgetDataCriteriaBuilder => {
        this.proxyContext = some(context);

        return this;
    };

    withReportInstanceId = (reportInstanceId: string): ReadWidgetDataCriteriaBuilder => {
        this.reportInstanceId = some(reportInstanceId);

        return this;
    };

    build = (): ReadWidgetDataCriteria => {
        if (isNone(this.widgetId)) {
            throw new ReferenceError('Undefined prop');
        }
        return new ReadWidgetDataCriteriaImpl(
            this.widgetId.value,
            isSome(this.destination) ? this.destination.value : 'widgets',
            isSome(this.proxyContext)
                ? this.proxyContext.value
                : { language: null, location: null, period: null, dashboardId: null, locationTags: null },
            isSome(this.reportInstanceId) ? this.reportInstanceId.value : null
        );
    };
}
